<template>
  <v-app-bar clipped-left flat app class="custom-app-bar" height="64px!important" >
    <v-app-bar-nav-icon
        class="hidden-md-and-up ml-2" 
        style=""
        @click.stop="drawer = !drawer"
    ></v-app-bar-nav-icon>
    <img class="hidden-sm-and-down" style="height:64px;" :src="currentTheme ? brandLogo.darkSrc : brandLogo.lightSrc">
    <div v-if="!isFetching">
      <div v-if="sites.length === 1">
        <v-chip class="ml-4">{{ sites[0].SitNom }}</v-chip>
      </div>
      <div v-if="sites.length>1 && $store.state.user.id !== 295">
        <v-select
          :items="sites"
          item-text="SitNom"
          item-value="SitId"
          v-model="selectedSite"
          item-color="allsan"
          append-icon="mdi-chevron-down" 
          style="min-width:120px!important;max-width:180px!important;"
          class="ml-4 custom"
          return-object
          :hide-details="true"
          rounded
          filled
          dense
          menu-props="auto"
          @change="changeSite"
        ></v-select>
      </div>
    </div>
    <v-spacer></v-spacer>
    <img class="hidden-callUs-down" style="height:auto;" :src="currentTheme ? phoneNumber.darkSrc : phoneNumber.lightSrc">
    <div class="center">
      <div id="menu-container"></div>
      <v-menu attach="#menu-container" :close-on-content-click="false" left v-model="displayMenu" @click="displayMenu = true">
        <template v-slot:activator="{ on }">
          <v-btn depressed class="hidden-myAccount-down custom-valid-btn account font-weight-medium" style="border:none!important" v-on="on">
            <v-icon style="padding-right:6px;margin-left:-3px;">mdi-account-circle</v-icon>
            {{ $t('account.title')}}
            <v-icon style="padding-left:6px;margin-right:-3px;">mdi-chevron-down</v-icon>
          </v-btn>
          <v-btn depressed small fab class="hidden-myAccount-up custom-valid-btn account font-weight-medium" style="border:none!important" v-on="on">
            <v-icon style="">mdi-account-circle</v-icon>
          </v-btn>
        </template>
        <AccountMenu />
      </v-menu>
      <v-btn depressed class="hidden-logOut-down custom-valid-btn connection font-weight-medium ml-2" style="border:none!important" @click="logout">{{ $t('header.logout-btn')}}
        <v-icon style="padding-left:6px;margin-right:-3px;">mdi-logout</v-icon>
      </v-btn>
      <v-btn depressed small fab class="hidden-logOut-up custom-valid-btn connection font-weight-medium ml-2" style="border:none!important" @click="logout">
        <v-icon style="margin-right:-3px;">mdi-logout</v-icon>
      </v-btn>
    </div>
  </v-app-bar>
</template>

<script>
import AccountMenu from './AccountMenu'
export default {
  data () {
    return {
      phoneNumber: {lightSrc: require('../assets/images/light_illu_bertrand.png'), darkSrc: require('../assets/images/dark_illu_bertrand.png')},
      brandLogo: {lightSrc: require('../assets/images/light_brand_allsan.gif'), darkSrc: require('../assets/images/dark_brand_allsan.gif')},
      sites: [],
      selectedSite: null,
      isFetching: true,
      displayMenu: false,
      currentTheme: null,
      drawer: null
    }
  },
  components: {
    AccountMenu
  },
  methods: {
    logout () {
      sessionStorage.removeItem('user')
      this.$store.dispatch('resetState', this.$store.state)
      this.$store.dispatch('setIsLoggedIn', false)
      this.$router.replace({
        name: 'Login'
      })
    },
    changeTheme () {
      this.currentTheme = this.$store.state.theme
    },
    closeMenu () {
      this.displayMenu = false
    },
    changeSite () {
      this.$store.dispatch('setSelectedSite', this.selectedSite)
      this.isFetching = false
      document.location.reload(true)
    }
  },
  created () {
    this.currentTheme = this.$store.state.theme  
  },
  async mounted () {
    this.drawer = this.$store.state.drawer
    if (this.$store.state.user.id === 295) {
      this.sites.push({
        SitNom: 'Tous'
      })
      this.sites = this.sites.concat(this.$store.state.user.sites)
    } else {
      this.sites = this.$store.state.user.sites
    }
    if (this.$store.state.selectedSite === null) {
      this.selectedSite = this.sites[0]
      this.$store.dispatch('setSelectedSite', this.selectedSite)
      this.isFetching = false
    } else {
      this.selectedSite = this.$store.state.selectedSite
      this.isFetching = false
    }    
  },
  watch: {
    isFetching () {
      if (!this.isFetching) {
        if (sessionStorage.getItem('currentroute') === null) {
          this.$router.replace({
            name: 'MyContent'
          })
        } else {
          window.location.replace(sessionStorage.getItem('currentroute'))
        }
      }
    },
    '$store.state.drawer': function() {
      this.drawer = this.$store.state.drawer
    },
    drawer () {
      this.$store.dispatch('setIsDrawer', this.drawer)
    }
  }
}
</script>

<style scoped>
</style>
